<ap-calendar-header></ap-calendar-header>

<div cdkMonitorSubtreeFocus tabindex="-1">
    @switch (currentView) {
        @case ('month') {
            <ap-month-view
                [(activeDate)]="activeDate"
                [selected]="selected()"
                [dateFilter]="dateFilter()"
                [maxDate]="maxDate()"
                [minDate]="minDate()"
                (selectedChange)="_dateSelected($event)"
                (_userSelection)="_userSelected()"
            >
            </ap-month-view>
        }
        @case ('year') {
            <ap-year-view
                [(activeDate)]="activeDate"
                [selected]="selected()"
                [dateFilter]="dateFilter()"
                [maxDate]="maxDate()"
                [minDate]="minDate()"
                (monthSelected)="_monthSelectedInYearView($event)"
                (selectedChange)="_goToDateInView($event, 'month')"
            >
            </ap-year-view>
        }
        @case ('multi-year') {
            <multi-year-view
                [(activeDate)]="activeDate"
                [selected]="selected()"
                [dateFilter]="dateFilter()"
                [maxDate]="maxDate()"
                [minDate]="minDate()"
                (yearSelected)="_yearSelectedInMultiYearView($event)"
                (selectedChange)="_goToDateInView($event, 'year')"
            >
            </multi-year-view>
        }
    }
</div>
